var map = {
	"../custom-attribute-option/custom-attribute-option.module": [
		"./src/app/components/custom-attribute-option/custom-attribute-option.module.ts"
	],
	"./components/acl/acl.module": [
		"./src/app/components/acl/acl.module.ts",
		"components-acl-acl-module"
	],
	"./components/cartrule/cartrule.module": [
		"./src/app/components/cartrule/cartrule.module.ts"
	],
	"./components/category/category.module": [
		"./src/app/components/category/category.module.ts",
		"components-category-category-module"
	],
	"./components/collection/collection.module": [
		"./src/app/components/collection/collection.module.ts",
		"components-collection-collection-module"
	],
	"./components/condition/condition.module": [
		"./src/app/components/condition/condition.module.ts",
		"components-condition-condition-module"
	],
	"./components/coupon/coupon.module": [
		"./src/app/components/coupon/coupon.module.ts"
	],
	"./components/courier/courier.module": [
		"./src/app/components/courier/courier.module.ts"
	],
	"./components/currency/currency.module": [
		"./src/app/components/currency/currency.module.ts"
	],
	"./components/custom-attribute/custom-attribute.module": [
		"./src/app/components/custom-attribute/custom-attribute.module.ts"
	],
	"./components/customer/customer.module": [
		"./src/app/components/customer/customer.module.ts"
	],
	"./components/delivery/delivery.module": [
		"./src/app/components/delivery/delivery.module.ts"
	],
	"./components/designer/designer.module": [
		"./src/app/components/designer/designer.module.ts"
	],
	"./components/order/order.module": [
		"./src/app/components/order/order.module.ts",
		"components-order-order-module"
	],
	"./components/payment/payment.module": [
		"./src/app/components/payment/payment.module.ts"
	],
	"./components/process-status-group/process-status-group.module": [
		"./src/app/components/process-status-group/process-status-group.module.ts"
	],
	"./components/process-status/process-status.module": [
		"./src/app/components/process-status/process-status.module.ts",
		"components-process-status-process-status-module"
	],
	"./components/process-transition/process-transition.module": [
		"./src/app/components/process-transition/process-transition.module.ts",
		"components-process-transition-process-transition-module"
	],
	"./components/process-types/process-types.module": [
		"./src/app/components/process-types/process-types.module.ts",
		"components-process-types-process-types-module"
	],
	"./components/product/product.module": [
		"./src/app/components/product/product.module.ts"
	],
	"./components/provider/provider.module": [
		"./src/app/components/provider/provider.module.ts",
		"components-provider-provider-module"
	],
	"./components/shipment/shipment.module": [
		"./src/app/components/shipment/shipment.module.ts",
		"components-shipment-shipment-module"
	],
	"./components/size/size.module": [
		"./src/app/components/size/size.module.ts"
	],
	"./components/status/status.module": [
		"./src/app/components/status/status.module.ts",
		"components-status-status-module"
	],
	"./components/style/style.module": [
		"./src/app/components/style/style.module.ts",
		"components-style-style-module"
	],
	"./components/user/user.module": [
		"./src/app/components/user/user.module.ts"
	],
	"./edit/edit.module": [
		"./src/app/components/customer/edit/edit.module.ts",
		"edit-edit-module"
	],
	"./event/event.module": [
		"./src/app/components/inventory/event/event.module.ts",
		"event-event-module"
	],
	"./offers-made/offers-made.module": [
		"./src/app/components/customer/edit/offers-made/offers-made.module.ts",
		"offers-made-offers-made-module"
	],
	"./roles/roles.module": [
		"./src/app/components/acl/roles/roles.module.ts",
		"roles-roles-module"
	],
	"./scan-rack/scan-rack.module": [
		"./src/app/components/inventory/scan-rack/scan-rack.module.ts",
		"scan-rack-scan-rack-module"
	],
	"./temporary-price/temporary-price.module": [
		"./src/app/components/product/temporary-price/temporary-price.module.ts",
		"temporary-price-temporary-price-module"
	],
	"./track-history/track-history.module": [
		"./src/app/components/inventory/scan-rack/track-history/track-history.module.ts",
		"track-history-track-history-module"
	],
	"./type/type.module": [
		"./src/app/components/destination/type/type.module.ts",
		"type-type-module"
	],
	"./wishlist/wishlist.module": [
		"./src/app/components/customer/edit/wishlist/wishlist.module.ts",
		"wishlist-wishlist-module"
	],
	"./wizard/wizard.module": [
		"./src/app/components/product/wizard/wizard.module.ts",
		"wizard-wizard-module"
	],
	"app/components/auth/auth.module": [
		"./src/app/components/auth/auth.module.ts"
	],
	"app/components/color/color.module": [
		"./src/app/components/color/color.module.ts"
	],
	"app/components/destination/destination.module": [
		"./src/app/components/destination/destination.module.ts"
	],
	"app/components/inventory/inventory.module": [
		"./src/app/components/inventory/inventory.module.ts"
	],
	"app/components/location/location.module": [
		"./src/app/components/location/location.module.ts"
	],
	"app/components/profile/profile.module": [
		"./src/app/components/profile/profile.module.ts"
	],
	"app/components/wardrobe/wardrobe.module": [
		"./src/app/components/wardrobe/wardrobe.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;